import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getOrders (callback, param) {
    if (param !== undefined) {
      HTTP.get('orders' + param).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getOrderById (callback, orderId) {
    if (orderId !== undefined) {
      HTTP.get('orders/' + orderId).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  exportOrders (callback, param) {
    if (param !== undefined) {
      HTTP.get('orders/history?language=' + param).then(response => {
        let blob = new Blob([response.data], { type: 'application/force-download' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'order.csv'
        link.click()
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getExportToken (callback, param) {
    HTTP.get('orders/token?start_date=' + param.start_date + '&end_date=' + param.end_date + '&update_start_date=' + param.update_start_date + '&update_end_date=' + param.update_end_date + '&keyword=' + param.keyword + '&order_type=' + param.order_type + '&order_status=' + param.order_status).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    })
  },
  getCountryList (callback, param) {
    if (param !== undefined) {
      HTTP.get('country/list?language=' + param).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getProvinceList (callback, param) {
    if (param !== undefined) {
      HTTP.get('account/province?language=' + param).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getDistrictList (callback, param) {
    if (param !== undefined) {
      HTTP.get('district/list?language=' + param.language + '&province_id=' + param.province_id).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getSubDistrictList (callback, param) {
    if (param !== undefined) {
      HTTP.get('subdistrict/list?language=' + param.language + '&district_id=' + param.district_id).then(response => {
        if (response.status === 200) {
          callback(response)
        } else if (response.status === 401) {
          HttpFunctions.response401()
        } else if (response.status === 403) {
          console.log('Error: pdo error message')
        }
      }).catch(e => {
        console.log(e)
      })
    }
  },
  getAllProductList (callback, param) {
    HTTP.get('orders/product/list?keyword=' + param).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getAddProductsVariant (callback, param) {
    HTTP.post('orders/product/variant', param).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getOrderDetailsByOrdersId (callback, param) {
    HTTP.get('orders/details/product?order_id=' + param).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getPostCode (callback, param) {
    HTTP.get('postcode?sub_district_id=' + param).then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  addNewOrder (callback, param) {
    HTTP.post('orders', param).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  updateNewOrder (callback, param) {
    HTTP.put('orders', param).then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  },
  getActiveDomain (callback) {
    HTTP.get('active/domain').then(response => {
      if (response.status === 201) {
        callback(response)
      } else if (response.status === 401) {
        HttpFunctions.response401()
      } else if (response.status === 403) {
        console.log('Error: pdo error message')
      }
    }).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/orders/index.js